import React from 'react'
import Loader from 'react-loader-spinner'
import MostyLogo from '../assets/images/logo_m_consultant.png'
import '../styles/components/FormButton.css'

const FormButtonWithIcon = ({ onClick, loading, type, className, children, Icon }) => {
  return (
    <button onClick={onClick} type={type || 'submit'}
      className={`form-button-container-with-icon
        ${loading ? 'form-button-loading' : ''}
        ${className || ''}`
      }>
      <img src={MostyLogo} alt='logo' className='img-logo' />
      {loading ? (
        <Loader
          type='TailSpin'
          color='white'
          height='20'
          width='20'
        />
      ) : (
        children
      )}
    </button>
  )
}

export default FormButtonWithIcon



// WEBPACK FOOTER //
// ./src/components/FormButtonWithIcon.js